module.exports = __webpack_public_path__ + "img/y21.1b21c2cc.jpg";